import cn from 'classnames'

import AppFlex from 'components/App/AppFlex'
import AppText from 'components/App/AppText'
import AppIcon from 'components/App/AppIcon'

import helper from './helper'

export type Props = {
  value: string | number | boolean
  checked: boolean
  label?: string
  small?: boolean
  large?: boolean
  size?: string | Array<string>
  disabled?: boolean
  admin?: boolean
  notActive?: boolean
  error?: string
  style?: React.CSSProperties
  className?: string
  onChange: (checked: boolean, value?: string | number | boolean) => void
}

const AppCheckbox: React.FC<Props> = (props) => {
  const classes = [
    ...helper.init(props),
    helper.checked(props),
    helper.disabled(props),
    props.className,
  ]

  const styles = {
    ...(props.style ?? {}),
  }

  const handleChange = () => {
    if (props.disabled) {
      return
    }

    props.onChange(!props.checked, props.value)
  }

  return (
    <AppFlex column fullWidth={!props.admin}>
      <label className={cn(classes)} style={styles}>
        <input
          type="checkbox"
          checked={props.checked}
          disabled={props.disabled}
          onChange={handleChange}
        />
        <span>{props.checked && <AppIcon icon="check" white small/>}</span>
        {props.label && <AppText>{props.label}</AppText>}
      </label>

      {props.error && props.error !== '' ? (
        <AppFlex>
          <AppText small danger>{props.error}</AppText>
        </AppFlex>
      ) : null}
    </AppFlex>
  )
}

export default AppCheckbox